/* eslint-disable import/prefer-default-export */
export const countArrInstances = (arr = [], funct) => {
    let count = 0;
    if (!Array.isArray(arr) || !funct) {
        return count;
    }

    for (let i = 0; i < arr.length; i += 1) {
        if (funct(arr[i])) {
            count += 1;
        }
    }
    return count || 0;
};

export const shuffle = (array) => {
    let currentIndex = array.length;
    let randomIndex;

    while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }

    return array;
};
